/**
 * Created by user on 2018/2/7/007.
 */

import { globalJsdom,  } from './index';
export = globalJsdom();
